// extracted by mini-css-extract-plugin
export var externalLink = "_b1-0";
export var internalLinkLabel = "_b1-1";